import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CachingService } from '@nk/caching-lib';
import {
  AppFeatureKey,
  AppRoleKey,
  CompanyEntity,
  CompanyRoleEntity,
  CompanyShareOwnershipEntity,
  CompanyShareOwnershipTypeEntity,
  PersonCompanyRoleEntity,
  PersonEntity,
  PersonMasterEntity,
  COUNTRY_FEATURES,
} from '@nk/data-entities-lib';
import { Observable } from 'rxjs';
import { AnalysisApiClientAccess } from '@nk/access-block';

export interface PersonCompanyPersonRelationshipEntity {
  uuid: string;
  company: CompanyEntity;
  subject_person: PersonEntity;
  subject_person_company_role: PersonCompanyRoleEntity;
  subject_company_role: CompanyRoleEntity;
  subject_company_share_ownership: CompanyShareOwnershipEntity;
  subject_company_share_ownership_type: CompanyShareOwnershipTypeEntity;
  related_person: PersonEntity;
  related_person_company_role: PersonCompanyRoleEntity;
  related_company_role: CompanyRoleEntity;
  related_company_share_ownership: CompanyShareOwnershipEntity;
  related_company_share_ownership_type: CompanyShareOwnershipTypeEntity;
}

export interface PersonNetworkRelationshipEntity {
  uuid: string;
  subject_person_master: PersonMasterEntity;
  subject_person_full_name: string;
  related_person_master: PersonMasterEntity;
  related_person_full_name: string;
  person_company_person_relationships: PersonCompanyPersonRelationshipEntity[];
}

@Injectable()
export class PersonNetworkService {
  constructor(
    private _analysisApi: AnalysisApiClientAccess,
    private _cachingService: CachingService,
  ) {}

  public personNetworkRelationshipCache = this._cachingService.create(this, this.fetchPersonNetworkRelationship);
  public fetchPersonNetworkRelationship(
    personMasterUuid: string,
    relatedPersonMinOwnership?: number,
    subjectPersonMinOwnership?: number,
  ): Observable<PersonNetworkRelationshipEntity[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('person_master_uuid', personMasterUuid);
    if (relatedPersonMinOwnership) {
      httpParams = httpParams.append('related_person_min_ownership', relatedPersonMinOwnership.toString());
    }
    if (subjectPersonMinOwnership) {
      httpParams = httpParams.append('subject_person_min_ownership', subjectPersonMinOwnership.toString());
    }

    return this._analysisApi.get<PersonNetworkRelationshipEntity[]>(
      'person-network-relationship',
      { params: httpParams },
      [AppFeatureKey.base, AppFeatureKey.norwegian_property_data, ...COUNTRY_FEATURES],
      [AppRoleKey.norwegian_property_data],
    );
  }
}
